import { createPinia } from 'pinia';
import useAppStore from './modules/app';
import useUserStore from './modules/user';
import useTabBarStore from './modules/tab-bar';
import useOrderAlertStore from './modules/orderAlert/index';

const pinia = createPinia();

export { useAppStore, useUserStore, useTabBarStore, useOrderAlertStore };
export default pinia;
